export function getPageContext() {
  const element = document.querySelector(`meta[name="page-context"]`);
  const content = element?.getAttribute("content");
  if (content) {
    try {
      return JSON.parse(content);
    } catch {
      return {};
    }
  }
}
